export default __webpack_public_path__ + "50497542602141690a5bb9d205bae78b.svg";